  <div class="mx-auto max-w-(--breakpoint-2xl) px-3">
  <div class="w-full">
    <div class="my-10 text-center">
      <h2 class="text-2xl font-medium text-gray-800 dark:text-white/90">
        @if (isNew) {
          Create Event Template
        } @else {
          Edit Event Template
        }
      </h2>
    </div>
  </div>

      <form [formGroup]="templateForm" (ngSubmit)="onSubmit()">
          <div class="mb-3 rounded-2xl w-full border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
      <div class="px-5 py-4 sm:px-6 sm:py-5">
        <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
          Template Information
        </h3>
      </div>
      <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div>
            <app-text-input
              [control]="nameControl"
              [label]="'Template Name'"
              [placeholder]="'Enter template name'"
              [required]="true">
            </app-text-input>
          </div>
          <div>
            <app-select
              [control]="eventTypeControl"
              [label]="'Event Type'"
              [choices]="eventTypes"
              [required]="true">
            </app-select>
          </div>
          <div>
            <app-select
              [control]="venueIdControl"
              [label]="'Venue Specific'"
              [choices]="venueChoices"
              [placeholder]="'All Venues'">
            </app-select>
          </div>
          <div class="sm:col-span-2">
            <app-textarea
              [control]="descriptionControl"
              [label]="'Description'"
              [placeholder]="'Describe this template'"
              [rows]="3">
            </app-textarea>
          </div>
        </div>
      </div>
          </div>


          <!-- Timeline Items Section -->
          <div class="mb-3 rounded-2xl w-full border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
      <div class="px-5 py-4 sm:px-6 sm:py-5 flex items-center justify-between">
        <div>
          <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
            Timeline Items
          </h3>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-1">
            Items are automatically sorted by days offset and time
          </p>
        </div>
        <button
          type="button"
          (click)="addItem()"
          class="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200 border border-gray-300 dark:border-gray-700 rounded-lg">
          <lucide-icon [name]="PlusIcon" [size]="16"></lucide-icon>
          Add Item
        </button>
      </div>
      <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">

        @if (itemsFormArray.length === 0) {
          <div class="text-center py-8 text-gray-500 dark:text-gray-400">
            <p>No timeline items added yet.</p>
            <p class="text-sm">Click "Add Item" to create your first timeline item.</p>
          </div>
        }

        <div formArrayName="items" class="space-y-4">
          @for (itemControl of itemsFormArray.controls; track $index) {
            <div [formGroupName]="$index" class="rounded-xl border border-gray-200 bg-gray-50 p-4 dark:border-gray-800 dark:bg-white/[0.03]">
              <div class="flex items-start justify-between mb-4">
                <div class="flex items-center gap-2">
                  <span class="text-sm font-medium text-gray-600">Item {{ $index + 1 }}</span>
                  <span class="text-xs font-medium text-blue-700 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30 px-2 py-1 rounded-md">
                    {{ formatOffsetDisplay(itemControl) }}
                  </span>
                </div>

                <div class="flex items-center gap-1">

                  <!-- Delete Button -->
                  <button
                    type="button"
                    (click)="removeItem($index)"
                    class="p-1 text-gray-500 hover:text-error-500 focus:outline-none focus:ring-2 focus:ring-red-500 rounded dark:text-gray-400 dark:hover:text-error-500">
                    <lucide-icon [name]="Trash2Icon" [size]="16"></lucide-icon>
                  </button>
                </div>
              </div>

              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                <app-text-input
                  [control]="getItemControl($index, 'name')"
                  [label]="'Item Name'"
                  [placeholder]="'e.g., Ceremony'"
                  [required]="true">
                </app-text-input>

                <app-text-input
                  [control]="getItemControl($index, 'offset_amount')"
                  [label]="'Amount'"
                  [placeholder]="'1'"
                  [type]="'number'"
                  [required]="true"
                  (change)="onOffsetChange($index)">
                </app-text-input>

                <app-select
                  [control]="getItemControl($index, 'offset_unit')"
                  [label]="'Unit'"
                  [choices]="[
                    {value: 'days', label: 'Days'},
                    {value: 'weeks', label: 'Weeks'},
                    {value: 'months', label: 'Months'}
                  ]"
                  [required]="true"
                  (change)="onOffsetChange($index)">
                </app-select>

                <app-select
                  [control]="getItemControl($index, 'offset_direction')"
                  [label]="'Direction'"
                  [choices]="[
                    {value: 'before', label: 'Before'},
                    {value: 'after', label: 'After'}
                  ]"
                  [required]="true"
                  (change)="onOffsetChange($index)">
                </app-select>

                <app-time-picker
                  [control]="getItemControl($index, 'time_of_day')"
                  [label]="'Time'"
                  [required]="true">
                </app-time-picker>
              </div>

              <div class="mt-4">
                <app-textarea
                  [control]="getItemControl($index, 'description')"
                  [label]="'Description'"
                  [placeholder]="'Describe this timeline item'"
                  [rows]="2">
                </app-textarea>
              </div>
            </div>
          }
        </div>

        <!-- Add Item button at bottom -->
        @if (itemsFormArray.length > 0) {
          <div class="flex justify-center pt-4">
            <button
              type="button"
              (click)="addItem()"
              class="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 hover:text-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200 border border-gray-300 dark:border-gray-700 rounded-lg">
              <lucide-icon [name]="PlusIcon" [size]="16"></lucide-icon>
              Add Item
            </button>
          </div>
        }
      </div>
          </div>

    <div class="mt-8 flex flex-row items-center justify-end gap-3">
      <app-button
        [label]="'Cancel'"
        [icon]="XIcon"
        [style]="'secondary'"
        [disabled]="saving"
        (click)="cancel()"
      ></app-button>

      <app-button
        [label]="'Save & Continue'"
        [icon]="CheckCircleIcon"
        [style]="'secondary'"
        [disabled]="templateForm.invalid || saving || templateForm.pristine"
        (click)="saveAndContinue()"
      ></app-button>

      <app-button
        [label]="'Save'"
        [icon]="CheckCircleIcon"
        [style]="'primary'"
        [disabled]="templateForm.invalid || saving || templateForm.pristine"
        (click)="save()"
      ></app-button>
    </div>
  </form>
</div>
